/* Bigoli - bulk pre-order basket.

   THE SHAPE OF IT. One entry row (dish, how many, note, Add). Pressing Add
   puts the dish into a visible list ABOVE the entry row, which is the order
   so far. Remove sits on each added line, where there is something real to
   remove. One Send at the end posts the lot.

   PROGRESSIVE ENHANCEMENT ONLY. Without this file the visitor gets the
   server-rendered dish rows - real controls, real name attributes, submitted
   in one go. The basket is layered on top: at boot this script strips the
   names off those rows, hides all but the first, and turns the first into the
   entry row. Corporate networks block scripts and catering customers sit
   behind them, so the no-JS path is not a courtesy, it is the fallback that
   has to work.

   THE PAYLOAD IS IDENTICAL EITHER WAY. Each basket line carries hidden inputs
   named contact[Item N dish|quantity|note] - exactly the fields the no-JS rows
   post. The email that lands at info@bigoli.com reads the same whichever path
   the customer took.

   THE DELIVERY MINIMUM IS GBP 150, AND THIS FORM CANNOT CHECK IT.
   Owner ruling, 22 Aug 2026 (evening): "minimum icerde kendi alirsa yok ama
   biz delivery yapacaksak minimum amount 150 olmali." Collection has no
   minimum at all; delivery needs GBP 150.

   This REPLACES the earlier "10 main dishes or GBP 150" rule, and it changes
   what the form can honestly say. The old rule had a dish-count half, so the
   script could count main dishes and tell the customer whether they had
   qualified. There is no dish-count half any more, and the page carries no
   prices by design - so the script has no way to evaluate GBP 150 and must
   not pretend otherwise. It states the rule and leaves the arithmetic to the
   call-back. MIN_MAINS is gone; do not reintroduce a threshold the form
   cannot actually measure.

   The main-dish count is still gathered and still goes in the email, because
   the shop finds it useful when pricing the job. It just no longer decides
   anything. "Main dish" is decided in Liquid: options in the groups named by
   the section's main_groups setting get data-main="1".
*/
(function () {
  'use strict';

  var MAX_LINES = 40;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function init(root) {
    var form = root.querySelector('form');
    var rowsWrap = root.querySelector('[data-cf-rows]');
    var addBtn = root.querySelector('[data-cf-add]');
    if (!form || !rowsWrap || !addBtn) return;

    var basket = root.querySelector('[data-cf-basket]');
    var list = root.querySelector('[data-cf-basket-list]');
    var emptyMsg = root.querySelector('[data-cf-basket-empty]');
    var totalEl = root.querySelector('[data-cf-basket-total]');
    var status = root.querySelector('[data-cf-status]');
    var entryError = root.querySelector('[data-cf-entry-error]');
    var sendHint = root.querySelector('[data-cf-send-hint]');
    var delNote = root.querySelector('[data-cf-delnote]');
    if (!basket || !list) return;

    var notes = root.querySelector('[data-cf-notes]');
    var bodyHidden = root.querySelector('[data-cf-body]');
    var hp = root.querySelector('[data-cf-hp]');
    var hpName = hp ? hp.name : '';
    var dateInput = root.querySelector('[data-cf-date]');
    var addressWrap = root.querySelector('[data-cf-address-wrap]');
    var addressInput = addressWrap ? addressWrap.querySelector('[data-cf-address]') : null;
    var addressName = addressInput ? addressInput.name : '';
    var okPanel = root.querySelector('[data-cf-ok]');

    var allRows = Array.prototype.slice.call(rowsWrap.querySelectorAll('[data-cf-row]'));
    if (!allRows.length) return;

    var entryRow = allRows[0];
    var entryDish = entryRow.querySelector('[data-cf-dish]');
    var entryQty = entryRow.querySelector('[data-cf-qty]');
    var entryNote = entryRow.querySelector('[data-cf-note]');
    if (!entryDish || !entryQty) return;

    // ---- take over from the no-JS markup -------------------------------

    // Every server-rendered row loses its name and its required flag. From
    // here on the only things that post are the basket's hidden inputs.
    allRows.forEach(function (row) {
      row.querySelectorAll('[data-cf-dish],[data-cf-qty],[data-cf-note]').forEach(function (el) {
        el.removeAttribute('name');
        el.removeAttribute('required');
      });
    });
    allRows.slice(1).forEach(function (row) { row.hidden = true; });

    entryRow.classList.add('is-entry');
    var entryHeading = entryRow.querySelector('[data-cf-rowno]');
    if (entryHeading) entryHeading.textContent = 'Add a dish';

    basket.hidden = false;
    addBtn.hidden = false;
    root.querySelectorAll('[data-cf-nojs]').forEach(function (el) { el.hidden = true; });
    root.querySelectorAll('[data-cf-jsonly]').forEach(function (el) { el.hidden = false; });

    // Today from the visitor's own clock, in case the page came from a cache
    // with a stale min attribute.
    if (dateInput) {
      var now = new Date();
      dateInput.min = now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
    }

    // ---- helpers --------------------------------------------------------

    function lines() {
      return Array.prototype.slice.call(list.querySelectorAll('[data-cf-line]'));
    }

    function val(sel) {
      var el = root.querySelector(sel);
      return el && el.value ? String(el.value).trim() : '';
    }

    function announce(msg) { if (status) status.textContent = msg; }

    function showError(msg) { if (entryError) entryError.textContent = msg; }

    function clearError() { if (entryError) entryError.textContent = ''; }

    function summary() {
      var portions = 0, mains = 0;
      var ls = lines();
      ls.forEach(function (li) {
        var n = parseInt(li.dataset.qty, 10);
        if (isNaN(n)) n = 0;
        portions += n;
        if (li.dataset.main === '1') mains += n;
      });
      return { count: ls.length, portions: portions, mains: mains };
    }

    function summaryText() {
      var s = summary();
      return s.count + ' line' + (s.count === 1 ? '' : 's') +
        ' · ' + s.portions + ' portion' + (s.portions === 1 ? '' : 's') +
        ' · ' + s.mains + ' main dish' + (s.mains === 1 ? '' : 'es');
    }

    function spokenSummary() {
      var s = summary();
      return s.count + ' line' + (s.count === 1 ? '' : 's') + ', ' +
        s.portions + ' portion' + (s.portions === 1 ? '' : 's') + ', ' +
        s.mains + ' main dish' + (s.mains === 1 ? '' : 'es');
    }

    function isDelivery() {
      var mode = root.querySelector('[data-cf-mode]:checked');
      return !!mode && mode.value.indexOf('Delivery') === 0;
    }

    // One fixed sentence. The form has no prices, so it cannot tell whether
    // an order reaches GBP 150 and must not imply that it can.
    function deliveryNoteText() {
      return 'Delivery is for orders of £150 and over. There are no prices on this form, so we will total it up and tell you on the call — if it comes in under, we will set it up as collection instead. Collection has no minimum.';
    }

    function updateDeliveryNote() {
      if (!delNote) return;
      if (!isDelivery()) { delNote.hidden = true; delNote.textContent = ''; return; }
      delNote.hidden = false;
      delNote.className = 'b-cf-delnote is-ok';
      delNote.textContent = deliveryNoteText();
    }

    function updateSummary() {
      var s = summary();
      if (emptyMsg) emptyMsg.hidden = s.count > 0;
      if (totalEl) { totalEl.hidden = s.count === 0; totalEl.textContent = summaryText(); }
      if (sendHint) sendHint.hidden = s.count > 0;
      updateDeliveryNote();
    }

    function hiddenInput(name, value) {
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = name;
      i.value = value;
      return i;
    }

    // Rewrites contact[Item N ...] across the whole basket so the numbering
    // is always 1..n with no gaps, whatever was removed.
    function renumberLines() {
      lines().forEach(function (li, i) {
        var k = i + 1;
        li.querySelectorAll('input[type="hidden"]').forEach(function (x) {
          x.parentNode.removeChild(x);
        });
        li.appendChild(hiddenInput('contact[Item ' + k + ' dish]', li.dataset.dish));
        li.appendChild(hiddenInput('contact[Item ' + k + ' quantity]', li.dataset.qty));
        if (li.dataset.note) {
          li.appendChild(hiddenInput('contact[Item ' + k + ' note]', li.dataset.note));
        }
      });
      updateSummary();
    }

    function buildLine(dish, qty, note, isMain) {
      var li = document.createElement('li');
      li.className = 'b-cf-line';
      li.setAttribute('data-cf-line', '');
      li.dataset.dish = dish;
      li.dataset.qty = String(qty);
      li.dataset.note = note;
      li.dataset.main = isMain ? '1' : '';

      var main = document.createElement('div');
      main.className = 'b-cf-line-main';

      var q = document.createElement('span');
      q.className = 'b-cf-line-qty';
      q.textContent = qty + ' ×';
      main.appendChild(q);

      var d = document.createElement('span');
      d.className = 'b-cf-line-dish';
      d.textContent = dish;
      main.appendChild(d);

      if (note) {
        var n = document.createElement('span');
        n.className = 'b-cf-line-note';
        n.textContent = note;
        main.appendChild(n);
      }

      var rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'b-cf-remove';
      rm.setAttribute('data-cf-line-remove', '');
      rm.appendChild(document.createTextNode('Remove'));
      var vh = document.createElement('span');
      vh.className = 'b-cf-vh';
      vh.textContent = ' ' + dish + ', ' + qty;
      rm.appendChild(vh);

      li.appendChild(main);
      li.appendChild(rm);
      return li;
    }

    // Returns true when a line was added, false when the entry row was not
    // usable. The submit handler relies on that answer.
    function addLine() {
      clearError();

      var dish = entryDish.value;
      if (!dish) {
        showError('Pick a dish before you press Add.');
        entryDish.focus();
        return false;
      }

      var raw = String(entryQty.value).trim();
      var qty = parseInt(raw, 10);
      if (!raw || isNaN(qty) || qty < 1) {
        showError('Say how many of the ' + dish + ' you want.');
        entryQty.focus();
        return false;
      }
      if (qty > 999) {
        showError('999 is the most on one line. Add a second line for the rest.');
        entryQty.focus();
        return false;
      }
      if (lines().length >= MAX_LINES) {
        showError('That is as many lines as the form takes. Put the rest in the notes below, or call us.');
        return false;
      }

      var opt = entryDish.options[entryDish.selectedIndex];
      var isMain = !!opt && opt.getAttribute('data-main') === '1';
      var note = entryNote ? String(entryNote.value).trim() : '';

      list.appendChild(buildLine(dish, qty, note, isMain));
      renumberLines();

      entryDish.selectedIndex = 0;
      entryQty.value = '';
      if (entryNote) entryNote.value = '';

      // Straight back to the dish select so the next one can be added
      // without hunting for it.
      entryDish.focus();
      announce(dish + ' ×' + qty + ' added. ' + spokenSummary() + '.');
      return true;
    }

    // ---- events ---------------------------------------------------------

    addBtn.addEventListener('click', function () { addLine(); });

    list.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-cf-line-remove]') : null;
      if (!btn) return;
      var li = btn.closest('[data-cf-line]');
      if (!li) return;

      var ls = lines();
      var idx = ls.indexOf(li);
      var dish = li.dataset.dish;
      var qty = li.dataset.qty;

      li.parentNode.removeChild(li);
      renumberLines();

      // Focus must never be left on the node that was just deleted.
      var after = lines();
      if (after.length) {
        var next = after[idx] || after[after.length - 1];
        var nextBtn = next.querySelector('[data-cf-line-remove]');
        (nextBtn || entryDish).focus();
      } else {
        entryDish.focus();
      }
      announce(dish + ' ×' + qty + ' removed. ' + spokenSummary() + '.');
    });

    // Enter anywhere in the entry row adds the dish. Without this, Enter in
    // the note field triggers implicit submission and sends the order
    // half-built - exactly what someone typing a note does not want. The Add
    // button is skipped so its own native activation still runs, once.
    entryRow.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-cf-add')) return;
      e.preventDefault();
      addLine();
    });

    function toggleAddress() {
      if (!addressWrap || !addressInput) return;
      var delivery = isDelivery();
      addressWrap.hidden = !delivery;
      if (delivery) {
        addressInput.setAttribute('required', '');
        if (addressName) addressInput.name = addressName;
      } else {
        addressInput.removeAttribute('required');
        addressInput.value = '';
        addressInput.removeAttribute('name');
      }
    }

    root.querySelectorAll('[data-cf-mode]').forEach(function (m) {
      m.addEventListener('change', function () {
        toggleAddress();
        updateDeliveryNote();
        if (isDelivery()) announce('Delivery chosen. ' + deliveryNoteText());
        else announce('Collection chosen. There is no minimum for collection.');
      });
    });

    // ---- the email body -------------------------------------------------

    function prettyDate(iso) {
      var p = String(iso).split('-');
      if (p.length !== 3) return iso;
      var d = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
      if (isNaN(d.getTime())) return iso;
      try {
        return d.toLocaleDateString('en-GB', {
          weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
        }) + ' (' + iso + ')';
      } catch (err) { return iso; }
    }

    function compose() {
      var L = [];
      var s = summary();
      var delivery = isDelivery();

      L.push('BULK PRE-ORDER REQUEST');
      L.push('');

      var dv = val('[data-cf-date]');
      L.push('Date needed: ' + (dv ? prettyDate(dv) : 'not given'));
      L.push('Time needed: ' + (val('[data-cf-time]') || 'not given'));

      var mode = root.querySelector('[data-cf-mode]:checked');
      L.push('Collection or delivery: ' + (mode ? mode.value : 'not given'));
      var addr = val('[data-cf-address]');
      if (addr) L.push('Delivery address: ' + addr);

      L.push('');
      L.push('Contact: ' + (val('[data-cf-name]') || 'not given'));
      L.push('Phone: ' + (val('[data-cf-phone]') || 'not given'));
      L.push('Email: ' + (val('[data-cf-email]') || 'not given'));
      var co = val('[data-cf-company]');
      if (co) L.push('Company: ' + co);
      L.push('');

      var ls = lines();
      if (ls.length) {
        L.push('ITEMS: ' + s.count + ' line' + (s.count === 1 ? '' : 's') +
          ', ' + s.portions + ' portions in total');
        ls.forEach(function (li) {
          L.push('- ' + li.dataset.qty + ' x ' + li.dataset.dish +
            (li.dataset.note ? '   (note: ' + li.dataset.note + ')' : ''));
        });
      } else {
        L.push('ITEMS: none picked on the form.');
      }

      L.push('');
      L.push('Main dishes: ' + s.mains + ' of ' + s.portions + ' portions');
      if (delivery) {
        L.push('DELIVERY REQUESTED. Minimum is £150.');
        L.push('The form carries no prices, so it could not check the total. Price the order up:');
        L.push('if it reaches £150 book the courier, if not confirm it as collection on the call.');
      } else {
        L.push('COLLECTION: no minimum applies.');
      }

      L.push('');
      L.push('NOTES AND ALLERGIES');
      var nv = notes && notes.value ? String(notes.value).trim() : '';
      L.push(nv ? nv : 'none given');

      L.push('');
      L.push('--');
      L.push('Sent from the bulk pre-order form at bigoli.com/pages/corporate-catering');
      L.push('No price was shown and nothing was paid. Ring the customer back to confirm the order and agree the price.');

      return L.join('\n');
    }

    // ---- submit ---------------------------------------------------------

    form.addEventListener('submit', function (e) {
      // Honeypot. Off-screen and out of the tab order, so a person never
      // reaches it. Anything in it came from a bot.
      if (hp && hp.value) { form.dataset.cfBlocked = '1'; e.preventDefault(); return; }

      // A dish sitting in the entry row that was never added would otherwise
      // be silently dropped. Add it rather than lose part of the order.
      if (entryDish.value) {
        if (!addLine()) { form.dataset.cfBlocked = '1'; e.preventDefault(); return; }
      }

      if (lines().length === 0) {
        form.dataset.cfBlocked = '1';
        e.preventDefault();
        showError('Add at least one dish before you send the order.');
        entryDish.focus();
        if (entryDish.scrollIntoView) entryDish.scrollIntoView({ block: 'center' });
        return;
      }

      // Every guard above passed: this submission is going out.
      form.dataset.cfBlocked = '0';

      if (hp) hp.removeAttribute('name');
      if (bodyHidden) {
        bodyHidden.value = compose();
        bodyHidden.name = 'contact[body]';
      }
      if (notes) notes.removeAttribute('name');
    });

    // Coming back through the history cache would otherwise restore a form
    // whose field names were stripped on the way out.
    window.addEventListener('pageshow', function () {
      if (notes) notes.name = 'contact[body]';
      if (bodyHidden) bodyHidden.removeAttribute('name');
      if (hp && hpName) hp.name = hpName;
      renumberLines();
      toggleAddress();
    });

    // ---- go -------------------------------------------------------------

    toggleAddress();
    renumberLines();
    if (okPanel && okPanel.focus) okPanel.focus();
  }

  function boot() {
    document.querySelectorAll('[data-bgl-cf]').forEach(function (r) { init(r); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
}());
